import { Route, Routes } from "react-router-dom";

import React from "react";
import AdministratorDashboard from "./AdministratorDashboard";
import ClassOverview from "./AdminClassOverview";
import TeachersOverview from "./TeachersOverview";
import StudentsOverview from "./StudentsOverview";
import ClassViewAdmin from "./ClassViewAdmin";
import TeacherView from "./TeacherView";
import StudentView from "./StudentView";

export const AdministratorRoutes = () => {
  return (
    <Routes>
      <Route path="home" element={<AdministratorDashboard />} />
      <Route path="classes/view/:id" element={<ClassViewAdmin />} />
      <Route path="classes" element={<ClassOverview />} />
      <Route path="teachers/view/:id" element={<TeacherView />} />
      <Route path="teachers" element={<TeachersOverview />} />
      <Route path="students/view/:id" element={<StudentView />} />
      <Route path="students" element={<StudentsOverview />} />
    </Routes>
  );
};
